<template>
  <div>
    <!--input/datepicker-->
    <div class="row mt-4 mb-2" v-if="users.length != 0">
      <div class="col-12 col-md-6 col-lg-3">
        <h5>Wyszukaj pracownika</h5>
        <b-form-input placeholder="Imię/Nazwisko/Email" type="text" v-model="filterTable"/>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <h5>Firma</h5>
        <b-form-select @change="onCompanyFilterChange" v-model="companyFilter">
          <option
            v-for="company in companies"
            :value="company.id"
            :key="company.id"
          >{{ company.name }}</option>
          <option disabled>------------------</option>
          <option :value="-2">Bez firmy</option>
        </b-form-select>
      </div>
      <div class="col-6 col-md-6 col-lg-3">
        <h5>Wybór dnia pracy</h5>
        <b-input-group>
          <b-btn
            style="border-color: #ced4da"
            slot="prepend"
            class="font-weight-bold d-none d-xl-block"
            variant="outline-secondary"
            @click="subtractDay"
          >&lsaquo;</b-btn>
          <date-picker
            class="date-picker"
            style="width: 190px"
            inputClass="form-control"
            v-model="workDayDate"
            :language="dpLanguage"
            :change="daysOfWork()"
            :format="'dd.MM.yyyy'"
          ></date-picker>
          <b-btn
            style="border-color: #ced4da"
            slot="append"
            class="font-weight-bold d-none d-xl-block"
            variant="outline-secondary"
            @click="addDay"
          >&rsaquo;</b-btn>
        </b-input-group>
      </div>
      <div class="col-6 col-md-6 col-lg-3 d-flex justify-content-end align-items-end">
        <b-btn variant="outline-primary" @click="onShowNewEmployeeForm">Dodaj pracownika</b-btn>
      </div>
    </div>
    <!--table-->
    <b-alert v-if="users.length <= 0" show variant="warning">Brak pracowników</b-alert>
    <table class="table table-hover" v-else>
      <thead>
        <tr>
          <th style="min-width: 22.5%">Pracownik</th>
          <th class="d-none d-md-table-cell" style="width: 22.5%">Adres email</th>
          <th class="text-center" style="min-width: 22.5%">Godzina przyjścia/wyjścia</th>
          <th
            class="text-center d-none d-lg-table-cell"
            style="min-width: 22.5%"
          >Czas w pracy / na przerwie</th>
          <th class="d-none d-md-table-cell" style="width: 10%"></th>
        </tr>
      </thead>
      <tbody class="text-left">
        <tr v-for="user in userFiltered" :key="user.id">
          <td>
            <router-link
              v-if="$isAdmin"
              :to="{ name: 'employee', params: { id: user.id } }"
            >{{ user.firstName }} {{ user.lastName }}</router-link>
          </td>
          <td class="d-none d-md-table-cell">{{ user.email }}</td>
          <td class="text-center" v-if="user.date === date">
            <span :id="'employee' + user.id">
              {{ user.start }}
              {{ user.end === '00:00' ? '' : ' - ' + user.end }}
            </span>
            <b-tooltip :target="() => 'employee' + user.id">
              <div>{{ typeof user.workTime == 'string' ? user.workTime : 'Czas w pracy: ' + convertMinutesToTime(user.workTime) }}</div>
              <div v-if="user.break">Czas przerw: {{ convertMinutesToTime(user.break) }}</div>
            </b-tooltip>
            <span v-if="user.break">
              <div
                class="circle bg-warning"
                style="width:10px; height:10px; border-radius: 30px; display:inline-block"
              ></div>
            </span>
          </td>
          <td class="text-center" v-else>{{ checkDayoffs(user.id) }}</td>
          <td class="text-center">
            <span
              v-if="user.date === date"
            >{{ typeof user.workTime == 'string' ? user.workTime : convertMinutesToTime(user.workTime) }}</span>
            <span v-if="user.break">&nbsp;/ {{ convertMinutesToTime(user.break) }}</span>
          </td>
          <td class="text-right d-none d-md-table-cell">
            <b-dropdown
              size="sm"
              split
              @click="editUser(user)"
              text="Edytuj"
              variant="outline-primary"
            >
              <b-dropdown-item @click="onOpenModal(user.id)">Usuń</b-dropdown-item>
            </b-dropdown>
          </td>
        </tr>
      </tbody>
    </table>
    <!--loader-->
    <loader :show="showLoader"></loader>
    <!--add modal-->
    <add
      v-if="addModal"
      :user="user"
      :addModal="addModal"
      @createNewEmployee="addEmployee"
      @cancel="onHideNewEmployeeForm"
      @edited="edit"
    ></add>
    <!--delete modal-->
    <confirm-modal
      v-if="confirmModal"
      :confirmModal="confirmModal"
      @cancel="onModalHide"
      @ok="removeUser"
    >
      <span slot="body">Czy na pewno chcesz usunąć tego pracownika?</span>
    </confirm-modal>
  </div>
</template>

<script>
import Add from './modals/Add.vue';
import Loader from '@/components/Loader.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

import DatePicker from 'vuejs-datepicker';
import { pl } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

import { UserResource } from '@/resources/user.resource';
import { WorkdayResource } from '@/resources/workday.resource';

export default {
  data() {
    return {
      user: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        repeatPassword: ''
      },
      allUsers: [],
      users: [],
      companyFilter: -1,
      workdays: [],
      dayoffs: [],
      companies: [{ id: -1, name: 'Wszystkie' }],
      userId: undefined,
      dpLanguage: pl,
      confirmModal: false,
      workDayDate: new Date(),
      filterTable: '',
      addModal: false,
      showLoader: true,
      date: '',
      day: 24 * 60 * 60 * 1000
    };
  },
  components: {
    Add,
    DatePicker,
    Loader,
    ConfirmModal
  },
  methods: {
    addDay() {
      this.workDayDate = new Date(this.workDayDate.getTime() + this.day);
    },
    subtractDay() {
      this.workDayDate = new Date(this.workDayDate.getTime() - this.day);
    },
    onHideNewEmployeeForm() {
      this.addModal = false;
      this.cleanInputs();
    },
    onShowNewEmployeeForm() {
      this.addModal = true;
    },
    onOpenModal(userId) {
      this.confirmModal = true;
      this.userId = userId;
    },
    onModalHide() {
      this.confirmModal = false;
    },
    onCompanyFilterChange(val) {
      this.$router.push({ query: { companyId: val } });
      if (val === -2) {
        this.users = this.allUsers.filter(user => user.card.length === 0);
      } else if (val !== -1) {
        this.users = this.allUsers.filter(user => user.card.map(company => company.company.id).indexOf(val) > -1);
      } else {
        this.users = this.allUsers;
      }
    },
    // Pobranie użytkowników z bazy
    async getUsers() {
      const data = await UserResource.usersAndCompanies();
      this.companies.push(...data.companies);
      this.showLoader = false;
      this.users = data.users;
      this.allUsers = data.users;
    },
    // Pobranie dni wolnych z bazy
    async daysOfWork() {
      const date = this.workDayDate;
      const day = parseInt(moment(date).format('D'), 10);
      const month = parseInt(moment(date).format('M'), 10);
      const year = parseInt(moment(date).format('YYYY'), 10);
      this.date = moment(date).format('l');
      const data = await WorkdayResource.workdaysAndDayoffs(day, month, year);
      this.convertWorkdaysToEvents(data.workdays);
      this.dayoffs = data.dayoffs;
    },
    // Konwersja dni pracujących
    convertWorkdaysToEvents(array) {
      this.workdays = [];
      array.forEach(workday => {
        if (workday.start) {
          const dayStart = moment(workday.date)
            .utc()
            .add(workday.start, 'minutes')
            .format('LT');
          const dayEnd = moment(workday.date)
            .utc()
            .add(workday.end, 'minutes')
            .format('LT');
          const id = workday.userId;
          const date = moment(workday.date).format('l');
          const index = this.workdays.map(item => item.userId).indexOf(id);
          if (index === -1) {
            this.workdays.push({
              userId: id,
              date,
              start: dayStart,
              end: dayEnd,
              endMinutes: workday.end,
              break: false,
              workTime: workday.end ? workday.end - workday.start : 'Ciężko pracuje'
            });
          } else {
            this.workdays.splice(index, 1, {
              userId: id,
              date,
              start: this.workdays[index].start < dayStart ? this.workdays[index].start : dayStart,
              end: this.workdays[index].end > dayEnd ? this.workdays[index].end : dayEnd,
              break: workday.start - this.workdays[index].endMinutes,
              workTime: workday.end ? this.workdays[index].workTime + (workday.end - workday.start) : 'Ciężko pracuje',
              endMinutes: workday.end
            });
          }
        }
      });
      this.getDaysTime();
    },
    // Dołączanie pól do użytkownika
    getDaysTime() {
      for (let i = 0; i < this.users.length; i++) {
        for (let j = 0; j < this.workdays.length; j++) {
          if (this.users[i].id === this.workdays[j].userId) {
            this.$set(this.users[i], 'start', this.workdays[j].start);
            this.$set(this.users[i], 'end', this.workdays[j].end);
            this.$set(this.users[i], 'date', this.workdays[j].date);
            this.$set(this.users[i], 'break', this.workdays[j].break);
            this.$set(this.users[i], 'workTime', this.workdays[j].workTime);
            break;
          }
        }
      }
    },
    // Sprawdzanie dni wolnych
    checkDayoffs(id) {
      for (let j = 0; j < this.dayoffs.length; j++) {
        if (this.dayoffs[j].userId === id) {
          return 'Nieobecność usprawiedliwiona';
        } else {
          return '-';
        }
      }
      for (let i = 0; i < this.users.length; i++) {
        if (this.date !== this.users[i].date) {
          return '-';
        }
      }
    },
    // Dodanie nowego pracownika
    async addEmployee(user) {
      this.users.push(user);

      user
        ? this.$notify({ type: 'success', title: 'Dodawanie pracownika', text: 'Pomyślnie dodano nowego pracownika' })
        : this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas dodawania pracownika' });

      this.onHideNewEmployeeForm();
    },

    generatePassword(form) {
      this.passwordGenerate = true;
      this.pass = '';
      const chars = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPRSTUWXYZ123456789';

      for (let i = 0; i < 8; i++) {
        const x = Math.floor(Math.random() * chars.length);
        this.pass += chars.charAt(x);
      }
      form.password.$value = this.pass;
      form.repeatPassword.$value = this.pass;
      return form;
    },
    // Usuwanie użytkownika
    async removeUser() {
      const userRemoved = await UserResource.delete(this.userId);

      userRemoved
        ? this.$notify({ type: 'success', title: 'Usuwanie pracownika', text: 'Pomyślnie usunięto pracownika' })
        : this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas usuwania pracownika' });

      this.users = this.users.filter(user => user.id !== this.userId);
      this.userId = undefined;
      this.confirmModal = false;
    },
    // Edycja użytkownika
    editUser(user) {
      this.user = { ...user };
      this.addModal = true;
    },
    async edit(user) {
      const id = this.users.map(usr => usr.id).indexOf(user.id);
      this.users.splice(id, 1, { ...user });

      user
        ? this.$notify({ type: 'success', title: 'Edycja pracownika', text: 'Pomyślnie edytowano dane pracownika' })
        : this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas edycji pracownika' });

      this.onHideNewEmployeeForm();
    },
    // Czyszczenie inputów
    cleanInputs() {
      this.user.email = '';
      this.user.firstName = '';
      this.user.lastName = '';
      this.user.password = '';
      this.user.repeatPassword = '';
      this.pass = '';
    },
    convertMinutesToTime(minutes) {
      const time = moment();
      time
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0);
      time.add(minutes, 'minutes');
      return time.format('LT').toString();
    }
  },
  computed: {
    // Filtrowanie tabeli
    userFiltered() {
      return this.users.filter(element => {
        return (element.lastName + ' ' + element.firstName + ' ' + element.email).toLowerCase().match(this.filterTable.toLowerCase() || '');
      });
    }
  },
  mounted() {
    this.getUsers();
    if (this.$route.query.day && this.$route.query.month && this.$route.query.year) {
      this.workDayDate = new Date(this.$route.query.year, this.$route.query.month - 1, this.$route.query.day);
    }
    if (this.$route.companyId) {
      this.companyFilter = this.$route.companyId;
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.day && to.query.month && to.query.year) {
        this.workDayDate = new Date(to.query.year, to.query.month - 1, to.query.day);
      }
      if (to.query.companyId) {
        this.onCompanyFilterChange(to.query.companyId);
        this.companyFilter = to.query.companyId;
      }
    },
    workDayDate(to, from) {
      this.$router.push({ query: { year: to.getFullYear(), month: to.getMonth() + 1, day: to.getDate() } });
    }
  }
};
</script>
<style>
.date-picker input.form-control:disabled,
.date-picker input.form-control[readonly] {
  background-color: white !important;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: white !important;
}
</style>
